var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-inner"},[_c('div',{staticClass:"side"},[_c('side-menu')],1),_c('div',{staticClass:"main"},[_c('div',{staticClass:"header"},[_c('custom-header')],1),_c('div',{staticClass:"content"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }